<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-UploadInformationModelImages-Title" slot="header">{{ $t('informationModelImagesUploadDialogTitle') }}</span>
    <el-form ref="data" :model="data" id="uploadform" @submit.native.prevent="save" enctype="multipart/form-data" label-position="left">
      <el-form-item
        :data-qa="`Dialog-UploadInformationModelImagesUpload-${key}`"
        :key="key"
        :label-width="labelWidth"
        :label="field.label"
        v-for="(field, key) in fieldsData"
      >
        <div class="image-block">
          <img @error="whenImageNotFound(key)" :src="field.currentImgSrc" height="34" v-show="field.currentImgSrc" />
          <input
            @change="filesChange(key, $event.target.name, $event.target.files)"
            :id="field.name"
            :name="field.name"
            accept="image/png, image/gif, image/jpg, image/jpeg"
            class="input-file"
            :data-qa="`Dialog-UploadInformationModelImages${key}-UploadImage`"
            type="file"
            v-bind="field.model"
            v-validate="field.validate"
          >
          <label :for="field.name" class="el-button el-button--default">{{ $t('informationModelImagesUploadButtonUploadImageText') }}</label>
          <div class="selected-file-name" v-if="field.isLocal || !field.uri">{{ field.selectedFileName }}</div>
          <el-button
            @click="removeImage(key, field.name)"
            :data-qa="`Dialog-UploadInformationModelImages${key}-RemoveImage`"
            v-show="field.uri && !field.isLocal"
          >
            {{ $t('informationModelImagesUploadButtonRemoveImageText') }}
          </el-button>
        </div>
        <div class="help is-danger" v-if="errors.has(field.name)">
          {{ errors.first(field.name) }}
        </div>
        <div class="help is-warning" v-if="!field.isValidImageSize">
          {{ field.imageErrorMsg }}
        </div>
        <div :data-qa="`Content-UploadInformationModelImages${key}-Description`" class="column-describe">
          <p v-if="field.uri">{{ field.uri }}</p>
          <i>{{ field.description }}</i>
        </div>
      </el-form-item>
    </el-form>
    <span slot="actions">
      <el-button
        @click="closePopup"
        class="btn-close"
        data-qa="Dialog-UploadInformationModelImages-Button-Cancel"
        type="text"
      >
        {{ $t('informationModelImagesUploadDialogButtonCloseText') }}
      </el-button>
      <el-button
        :disabled="loading || errors.any()"
        :loading="loading"
        @click="save"
        data-qa="Dialog-UploadInformationModelImages-Button-Save"
        type="warning"
      >
        {{ $t('informationModelImagesUploadDialogButtonSaveText') }}
      </el-button>
    </span>
  </hamv-dialog>
</template>

<script>
  import main from './InformationModelImagesUpload.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './InformationModelImagesUpload.scss'
</style>



// WEBPACK FOOTER //
// InformationModelImagesUpload.vue?5ccfa335